export default __webpack_public_path__ + "static/media/cover.0d72ecf5.png";